import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import axios from 'axios';
import FeatherIcon from 'feather-icons-react';
import { notification } from 'antd';
import { API_URL, ENDPOINTS } from '../constants/api';
import { getToken, decodeToken } from '../utils/TokenUtils';
import { useTranslation } from 'react-i18next';

const NavigationPage = ({ onNavigate }) => {
  const { t } = useTranslation();

  const token = getToken();
  const companyName = decodeToken(token, 'companyName');

  const [categories, setCategories] = useState([]);
  const [links, setLinks] = useState([]);

  useEffect(() => {
    let url;

    if (
      companyName?.toLowerCase().includes('imaam') &&
      companyName?.toLowerCase().includes('shaafici')
    ) {
      url = `${API_URL}/${ENDPOINTS.SYS}/get-categories2`;
    } else {
      url = `${API_URL}/${ENDPOINTS.SYS}/get-categories`;
    }

    axios
      .get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      })
      .then((res) => {
        setCategories(res.data.categories);
        setLinks(res.data.links);
      })
      .catch((err) => {
        notification.error({
          message: err?.response?.data?.message || 'Failed to load navigation',
        });
      });
  }, [token]);

  return (
    <div className="container-fluid py-4">
      <div className="row g-4">
        {categories.map((cat) => {
          const catLinks = links.filter(
            (l) => l.category_id === cat.category_id
          );

          if (!catLinks.length) return null;

          return (
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-sm-12"
              key={cat.category_id}
            >
              <div className="card h-100 shadow-sm">
                <div className="card-header bg-primary text-white">
                  <h5 className="mb-0 d-flex align-items-center">
                    <FeatherIcon
                      icon={cat.category_icon}
                      className="me-2"
                      size={18}
                    />

                    {t(cat.category)}

                    <span className="badge bg-light text-dark ms-auto">
                      {catLinks.length}
                    </span>
                  </h5>
                </div>

                <div className="card-body">
                  <ul className="mb-0">
                    {catLinks.map((link) => (
                      <li key={link.id} className="mb-2">
                        <NavLink
                          to={`/${link.full_route}`}
                          className="text-decoration-none"
                          onClick={() => {
                            if (onNavigate) {
                              onNavigate();
                            }
                          }}
                        >
                          {t(link.name)}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NavigationPage;
